import { render, staticRenderFns } from "./citiesAutocomplete.vue?vue&type=template&id=5b88a051&scoped=true"
import script from "./citiesAutocomplete.vue?vue&type=script&lang=js"
export * from "./citiesAutocomplete.vue?vue&type=script&lang=js"
import style0 from "./citiesAutocomplete.vue?vue&type=style&index=0&id=5b88a051&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b88a051",
  null
  
)

export default component.exports